// Recording tags in search (design 5.3, "Accelerator session tags"): the product boards' header
// search finds a recording by a topic it's tagged with, "Delayed completion" under "The Property
// Accelerator, Group 2 recording, 27 Sep" (Accelerator.dc.html, POYT.dc.html, FEHome.dc.html). Tags
// aren't in the Library's rows (library/search.js indexes titles, chapters and resources), so the
// search asks the database as the member, through row level security: hub.search_recordings
// (docs/data-model.md 10.6.1) gives the recordings they can read whose title or a tag holds the
// words, with the tags that matched. Each matched tag is 1 result; a title match is already in the
// Library's own index.
//
//   const tags = useTagSearch(query, { enabled })     [] until the database answers, [] on a failure
//   mergeResults(searchIn(index, query, 5), tags, 5)  the Library's results first, then the tags'
//
// tagResults, tagWhere and mergeResults are in tagResults.js, pure, so a test can import them.
import { useEffect, useState } from 'react'
import { supabase, must } from './supabase.js'
import { tagResults } from './tagResults.js'

export { mergeResults, tagResults, tagWhere } from './tagResults.js'

// Fewer letters than this match nearly every tag, so the database isn't asked
export const TAG_SEARCH_MIN = 2
const WAIT_MS = 200
const LIMIT = 20

export function useTagSearch(query, { enabled = true } = {}) {
  const term = String(query || '').trim()
  const ask = enabled && term.length >= TAG_SEARCH_MIN && Boolean(supabase)
  const [found, setFound] = useState({ term: '', results: [] })
  useEffect(() => {
    if (!ask) return undefined
    let live = true
    const timer = setTimeout(() => {
      supabase.rpc('search_recordings', { p_q: term, p_product: null, p_topic: null, p_limit: LIMIT }).then(must)
        .then(rows => { if (live) setFound({ term, results: tagResults(rows) }) })
        .catch(() => { if (live) setFound({ term, results: [] }) })
    }, WAIT_MS)
    return () => { live = false; clearTimeout(timer) }
  }, [ask, term])
  return ask && found.term === term ? found.results : []
}
